import React, { useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import {
  getAllServiceGroups,
  getAllServices,
  assignServiceToGroup
} from "../../Services/dynamicservice";

function AssignServiceGroup() {

  const [groups, setGroups] = useState([]);
  const [services, setServices] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState("");
  const [selectedServices, setSelectedServices] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchGroups();
    fetchServices();
  }, []);

  const fetchGroups = async () => {
    const data = await getAllServiceGroups();
    setGroups(data);
  };

  const fetchServices = async () => {
  const data = await getAllServices();

  // Filter only child services (parentServiceId NOT null)
  const filteredServices = data.filter(
    service => service.parentServiceId !== null
  );

  setServices(data);
};

const handleRemove = async (serviceId) => {
  if (!window.confirm("Remove this service from group?")) return;

  try {
    await assignServiceToGroup(serviceId, {
      serviceGroupId: 0,
      displayOrder: 0
    });

    // Re-normalize remaining orders
    const remaining = assignedServices
      .filter(s => s.id !== serviceId)
      .sort((a, b) => a.displayOrder - b.displayOrder);

    for (let i = 0; i < remaining.length; i++) {
      await assignServiceToGroup(remaining[i].id, {
        serviceGroupId: Number(selectedGroupId),
        displayOrder: i + 1
      });
    }

    fetchServices();
  } catch (err) {
    alert("Failed to remove");
  }
};


const moveUp = async (index) => {
  if (index === 0) return;

  const current = assignedServices[index];
  const previous = assignedServices[index - 1];

  try {
    await assignServiceToGroup(current.id, {
      serviceGroupId: Number(selectedGroupId),
      displayOrder: previous.displayOrder
    });

    await assignServiceToGroup(previous.id, {
      serviceGroupId: Number(selectedGroupId),
      displayOrder: current.displayOrder
    });

    fetchServices();
  } catch (err) {
    alert("Failed to reorder");
  }
};


const moveDown = async (index) => {
  if (index === assignedServices.length - 1) return;

  const current = assignedServices[index];
  const next = assignedServices[index + 1];

  try {
    await assignServiceToGroup(current.id, {
      serviceGroupId: Number(selectedGroupId),
      displayOrder: next.displayOrder
    });

    await assignServiceToGroup(next.id, {
      serviceGroupId: Number(selectedGroupId),
      displayOrder: current.displayOrder
    });

    fetchServices();
  } catch (err) {
    alert("Failed to reorder");
  }
};




  const unassignedServices = services.filter(s => !s.serviceGroupId);

  const assignedServices = services
    .filter(s => s.serviceGroupId === Number(selectedGroupId))
    .sort((a, b) => a.displayOrder - b.displayOrder);

  const handleSelect = (id) => {
    setSelectedServices(prev =>
      prev.includes(id)
        ? prev.filter(x => x !== id)
        : [...prev, id]
    );
  };

  const handleAssign = async () => {
  if (!selectedGroupId) {
    alert("Please select group");
    return;
  }

  try {
    setLoading(true);

    // Get current assigned services
    const currentAssigned = services
      .filter(s => s.serviceGroupId === Number(selectedGroupId))
      .sort((a, b) => a.displayOrder - b.displayOrder);

    let lastOrder =
      currentAssigned.length > 0
        ? currentAssigned[currentAssigned.length - 1].displayOrder
        : 0;

    // Append new services after last order
    for (let i = 0; i < selectedServices.length; i++) {
      lastOrder++;

      await assignServiceToGroup(selectedServices[i], {
        serviceGroupId: Number(selectedGroupId),
        displayOrder: lastOrder
      });
    }

    alert("Services assigned successfully");
    setSelectedServices([]);
    fetchServices();

  } catch (error) {
    alert("Assignment failed");
  } finally {
    setLoading(false);
  }
};


  return (
    <div>
      <div className="wrapper">
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">

              {/* PAGE TITLE */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box">
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="/dashboard">Dashboard</Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Assign Service Group
                        </li>
                      </ol>
                    </div>
                    <h4 className="page-title">
                      Assign Services To Group
                    </h4>
                  </div>
                </div>
              </div>

              {/* MAIN CARD */}
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">

                      {/* SELECT GROUP */}
                      <div className="row g-2">
                        <div className="mb-3 col-md-6">
                          <label className="form-label">
                            Select Service Group
                          </label>
                          <select
                            className="form-control"
                            value={selectedGroupId}
                            onChange={(e) => setSelectedGroupId(e.target.value)}
                          >
                            <option value="">-- Select Group --</option>
                            {groups.map(group => (
                              <option key={group.id} value={group.id}>
                                {group.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {selectedGroupId && (
                        <div className="row mt-4">

                          {/* UNASSIGNED SERVICES */}
                          <div className="col-md-6">
                            <div className="card border">
                              <div className="card-body">
                                <h5 className="mb-3">
                                  Unassigned Services
                                </h5>

                                <div className="list-group">
                                  {unassignedServices.length > 0 ? (
                                    unassignedServices.map(service => (
                                      <label
                                        key={service.id}
                                        className="list-group-item"
                                      >
                                        <input
                                          type="checkbox"
                                          className="form-check-input me-2"
                                          onChange={() => handleSelect(service.id)}
                                          checked={selectedServices.includes(service.id)}
                                        />
                                        {service.name}
                                      </label>
                                    ))
                                  ) : (
                                    <p className="text-muted">
                                      No unassigned services
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* ASSIGNED SERVICES */}
                          <div className="col-md-6">
                            <div className="card border">
                              <div className="card-body">
                                <h5 className="mb-3">
                                  Assigned To This Group
                                </h5>

                                <ul className="list-group">
  {assignedServices.length > 0 ? (
    assignedServices.map((service, index) => (
      <li
        key={service.id}
        className="list-group-item d-flex justify-content-between align-items-center"
      >
        <div>
          <strong>{service.name}</strong>
          <span className="badge bg-primary ms-2">
            Order: {service.displayOrder}
          </span>
        </div>

        <div className="btn-group btn-group-sm">
          <button
            className="btn btn-outline-secondary"
            onClick={() => moveUp(index)}
          >
            ↑
          </button>

          <button
            className="btn btn-outline-secondary"
            onClick={() => moveDown(index)}
          >
            ↓
          </button>

          <button
            className="btn btn-outline-danger"
            onClick={() => handleRemove(service.id)}
          >
            Remove
          </button>
        </div>
      </li>
    ))
  ) : (
    <p className="text-muted">No services assigned yet</p>
  )}
</ul>


                              </div>
                            </div>
                          </div>

                        </div>
                      )}

                      {/* ASSIGN BUTTON */}
                      {selectedGroupId && (
                        <div className="mt-4">
                          <button
                            className="btn btn-success"
                            onClick={handleAssign}
                            disabled={loading}
                          >
                            {loading ? "Assigning..." : "Assign Selected →"}
                          </button>
                        </div>
                      )}

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <Outlet />
    </div>
  );
}

export default AssignServiceGroup;
